import { Button, Box, Stack } from "@mui/material"
import { Alert } from "@mui/material"
import { Login } from "@mui/icons-material"
import { OrDivider } from "../common/OrDivider"
import { isCancelError } from "../errors/errors.shared"
import { ErrorAlert } from "../errors/ErrorMessage"
import { Link } from "react-router"
import { ROUTES } from "../navigation/routes"
import { SignUpForm } from "../auth/SignUpForm"
import { AuthPage } from "../auth/AuthPage"
import { useSignUp } from "../auth/useSignUp"

export const SignUpScreen = () => {
  const { mutate, error, status } = useSignUp()

  return (
    <AuthPage>
      {status === "success" ? (
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Alert severity="success">
            Check your inbox for a link to finish creating your account.
          </Alert>
        </Box>
      ) : null}
      {error && !isCancelError(error) ? (
        <Box
          sx={{
            mb: 2,
          }}
        >
          <ErrorAlert error={error} />
        </Box>
      ) : null}
      <SignUpForm onSubmit={mutate} />
      <OrDivider title="or" />
      <Stack
        sx={{
          gap: 1,
        }}
      >
        <Button
          component={Link}
          to={ROUTES.LOGIN}
          size="large"
          startIcon={<Login />}
        >
          Sign in
        </Button>
      </Stack>
    </AuthPage>
  )
}
